import { render, staticRenderFns } from "./locationwisereport.vue?vue&type=template&id=c6b5d7f0&scoped=true&"
import script from "./locationwisereport.vue?vue&type=script&lang=js&"
export * from "./locationwisereport.vue?vue&type=script&lang=js&"
import style0 from "./locationwisereport.vue?vue&type=style&index=0&id=c6b5d7f0&prod&lang=css&"
import style1 from "./locationwisereport.vue?vue&type=style&index=1&id=c6b5d7f0&prod&lang=scss&scoped=true&"
import style2 from "./locationwisereport.vue?vue&type=style&index=2&id=c6b5d7f0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6b5d7f0",
  null
  
)

export default component.exports